import { useTheme } from 'beam'
import { ReactElement, useEffect } from 'react'

export interface AgGridThemeProviderProps {
  children: ReactElement,
}

export function AgGridThemeProvider({ children }: AgGridThemeProviderProps): ReactElement {
  const theme = useTheme()
  useEffect(
    () => {
      document.documentElement.style.setProperty('--ag-material-accent-color', theme.palette.secondary.main)
      document.documentElement.style.setProperty('--ag-checkbox-unchecked-color', theme.palette.secondary.dark)
    },
    [theme.palette.secondary.main, theme.palette.secondary.dark],
  )
  return children
}
